/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './signup.scss';

import uiRouter from 'angular-ui-router';
import thingsboardApiSignUp from '../api/signup.service';
import thingsboardApiLogin from '../api/login.service';
import thingsboardApiUser from '../api/user.service';
import thingsboardToast from '../services/toast';

import SignUpRoutes from './signup.routes';
import SignUpController from './signup.controller';
import EmailVerificationController from './email-verification.controller';
import EmailVerifiedController from './email-verified.controller';

export default angular.module('thingsboard.signup', [
    uiRouter,
    thingsboardApiSignUp,
    thingsboardApiLogin,
    thingsboardApiUser,
    thingsboardToast
])
    .config(SignUpRoutes)
    .controller('SignUpController', SignUpController)
    .controller('EmailVerificationController', EmailVerificationController)
    .controller('EmailVerifiedController', EmailVerifiedController)
    .name;

